import { PersonTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { Utils } from "utils/Utils";
import { SubscribersActions } from "./SubscribersActions";
import { EditionsActions } from "./EditionActions";
import { UiActions } from "../UiActions";
import { GlamboxLocalStore } from "core/glambox/GlamboxLocalStore";
import { PartnerInfoActions } from "./PartnerInfoActions";
import { PartnerSalesActions } from "./PartnerSalesActions";
import { PartnerGeneralActions } from "./PartnerGeneralActions";
import { DatetimeToLocaleDate } from "core/utils/Utils";
import { InstagramInfoSet } from "./InstagramInfoActions";
import { IgProfileRequest } from "components/person/Instagram";

// ----------------------------------------------------------------------

/**
 * Contém todas as actions necessárias para gerenciar o person.
 *
 * @type {Object}
 * @since 0.0.1
 */
export const PersonActions = {};

// THUNKS
// ----------------------------------------------------------------------
PersonActions.setCouponName = (newCouponName, cb = null) => {

  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    ExecuteRequest(
      GlamboxEndpoints.Person.editCouponName,
      Object.assign({},newCouponName),
      "PUT",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PersonActions.pending(false));

        if (statusCode === 200) {
          dispatch(PersonActions.success(true));

        } else {
          dispatch(
            PersonActions.error(
              (result && result.message)
                ? result.message
                : "Erro"
            )
          );
        }

        if (cb) {
          cb(response);
        }
      }
    )
  }
}


PersonActions.setSubscriberEditions = (subscribers, editionsQueueId) => {
  return (dispatch) => {
    dispatch(UiActions.dequeue(editionsQueueId));
    dispatch(SubscribersActions.set(subscribers));
    //TODO: DESCOMENTAR
    //dispatch(EditionsActions.fetch());

  };
};

PersonActions.fetch = (callback = null) => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    dispatch(PersonActions.start());

    let queueId = "Person-" + Date.now();
    dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.Person.info,
      null,
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PersonActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {

          if (typeof callback === 'function') {
            callback();
          }

          dispatch(PersonActions.success(true));

          let { birthday } = result.person;

          if (birthday !== null) {
            result.person.birthday = DatetimeToLocaleDate(birthday);
          }

          dispatch(PersonActions.set(result));
          
          if(result.insta) {
            dispatch(PersonActions.instagram(result.insta.username)); 
          }      

          if (localStorage) {
            let localStore = new GlamboxLocalStore();
            localStore.set("PersonGeral", result);
          }

          let editionsQueueId = "EditionsQueueId-" + Date.now();
          dispatch(UiActions.queue(editionsQueueId));

          dispatch(SubscribersActions.set(result.subs));
          dispatch(PersonActions.setSubscriberEditions(result.subs, editionsQueueId));

        } else {
          dispatch(
            PersonActions.error(
              (result && result.message)
                ? result.message
                : "Erro"
            )
          );
        }
      }
    );
  };
};

PersonActions.instagram = (instagramUsername) => {
  return async (dispatch, getState) => {
    let data = await IgProfileRequest(
      instagramUsername
    );

    const { result, statusCode } = data;
    const hasOwn = {}.hasOwnProperty;

    if (!result) return null;
    if (statusCode === 200 && hasOwn.call(result, "graphql")) {
      dispatch(InstagramInfoSet(result["graphql"]["user"] || null));
    }
  }

}


PersonActions.isInfluencer = () => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    dispatch(PersonActions.start());

    let queueId = "IsInfluencer-" + Date.now();

    dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.Partner.getPartner,
      null,
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PersonActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(PartnerGeneralActions.fetch());
          dispatch(PartnerInfoActions.fetch());

          // let currDate = new Date();

          // dispatch(
          //   PartnerSalesActions.fetch(
          //     currDate.getMonth() + 1, 
          //     currDate.getFullYear()
          //   )
          // );
        } else {
          dispatch(
            PersonActions.error(
              (result && result.message)
                ? result.message
                : "Erro"
            )
          );
          // dispatch(UiActions.publishErrorAlert(message || error.message));
        }
      }
    );
  };
};

PersonActions.updatePerson = (person, callback) => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    let requestData = Object.assign(
      {},
      person
    );

    dispatch(PersonActions.start());

    dispatch(UiActions.loaderShow());

    ExecuteRequest(
      GlamboxEndpoints.Person.infoUpdate,
      requestData,
      "PUT",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PersonActions.pending(false));

        dispatch(UiActions.loaderHide());

        if (statusCode === 200) {
          dispatch(PersonActions.success(true));

          // let { birthday } = result;
          // if (birthday !== null) {
          //   result.birthday = DatetimeToLocaleDate(birthday);
          // }

          dispatch(
            PersonActions.updatePersonInfo(
              requestData
            )
          );

          dispatch(
            UiActions.publishSuccessAlert(
              (result && result.message)
                ? result.message
                : "Dados atualizados com sucesso."
            )
          );

          if (callback) callback(response);
        } else {
          dispatch(
            PersonActions.error(
              (result && result.message)
                ? result.message
                : "Erro"
            )
          );
        }
      }
    );
  };
};

PersonActions.start = () => {
  return (dispatch) => {
    dispatch(PersonActions.pending(true));
    dispatch(PersonActions.success(false));
    dispatch(PersonActions.error(null));
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

PersonActions.setInstagram = (insta = null, avatar = null) => ({
  insta: insta,
  avatar: avatar,
  type: PersonTypes.instagramSet
});

PersonActions.sync = () => ({
  person: {
    lastSync: Date.now()
  },
  type: PersonTypes.sync
});

PersonActions.updatePersonInfo = (personInfo) => {
  return {
    person: personInfo,
    type: PersonTypes.updatePerson
  };
};

PersonActions.set = (person) => ({
  person: {
    data: person,
    lastSync: Date.now()
  },
  type: PersonTypes.set
});

PersonActions.unset = () => ({
  person: InitialState.createSyncObject(),
  type: PersonTypes.unset
});

PersonActions.success = (success) => ({
  person: {
    success: (success === true)
  },
  type: PersonTypes.success
});

PersonActions.pending = (pending) => ({
  person: {
    pending: (pending === true)
  },
  type: PersonTypes.pending
});

PersonActions.error = (error) => ({
  person: {
    error
  },
  type: PersonTypes.error
});
